<template>
    <div class="container-fluid" >
        <slot></slot>
    </div>
</template>

<script>
    export default {
        mounted(){
            $(function () {
                $('[data-toggle="tooltip"]').tooltip()
            })
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// resources/assets/js/views/jobs/JobShowPage.vue